const initialState ={
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case 'SWITCH_WORKSPACE':
      newState=initialState;
      break;
    case 'REQUEST_INDEX_SHORT_CODES_SUCCESS':
      if(newState.short_codes==undefined || newState.short_codes=='loading'){newState.short_codes={}}
      for (let short_code of action.val) { newState.short_codes[short_code.unique_code.toUpperCase().replace(/ /g, '_')]=short_code;}
      newState.refresh+=1;
    break;
    case 'REQUEST_CREATE_SHORT_CODE_SUCCESS':
    case 'REQUEST_UPDATE_SHORT_CODE_SUCCESS':
    case 'REQUEST_GET_SHORT_CODE_SUCCESS':
    case 'REQUEST_CLONE_SHORT_CODE_SUCCESS':
      if(newState.short_codes==undefined){newState.short_codes={}}
      if (action.val.old_code != undefined) { if (newState.short_codes[action.val.old_code.toUpperCase().replace(' ', '_')] != undefined) { delete newState.short_codes[action.val.old_code.toUpperCase().replace(/ /g, '_')]} delete action.val.old_code;}
      newState.short_codes[action.val.unique_code.toUpperCase().replace(/ /g, '_')]=action.val;
      newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_SHORT_CODE_SUCCESS':
      delete newState.short_codes[action.val.unique_code.toUpperCase().replace(/ /g, '_')];
      newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_HTML_TEMPLATE_SUCCESS':
      delete newState.templates[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_DELETE_EMAIL_SEQUENCE_SUCCESS':
      delete newState.sequences[action.val];
      newState.refresh+=1;
      break;
    case 'REQUEST_GET_HTML_TEMPLATE_INSTANCE_SUCCESS':
      console.log('GOT INSTANCE');
      if(newState.template_instances==undefined){newState.template_instances={}}
      newState.template_instances[action.val.id]=action.val;
      newState.refresh+=1;
      break;
    case 'REQUEST_CREATE_HTML_TEMPLATE_SUCCESS':
    case 'REQUEST_CLONE_HTML_TEMPLATE_SUCCESS':
    case 'REQUEST_GET_HTML_TEMPLATE_SUCCESS':
    case 'REQUEST_UPDATE_HTML_TEMPLATE_SUCCESS':
      if(newState.templates==undefined){newState.templates={}}
      if(newState.template_instances==undefined){newState.template_instances={}}
      console.log(action.val, 'GOO');
      if(action.val.html_templates!=undefined){
        for(let ht of action.val.html_templates){
          let instance=ht.html_template_instances[0];
          newState.templates[ht.id]={...ht, html:instance.html, subject:instance.subject, html_template_instance_id:instance.id, html_template_instances:undefined};
          newState.template_instances[instance.id]=instance;
        }
      }else{
        let instance=action.val.html_template_instances[0];
        newState.templates[action.val.id]={...action.val, html:instance.html, subject:instance.subject, html_template_instance_id:instance.id, html_template_instances:undefined};
        newState.template_instances[instance.id]=instance;
      }
      console.log('NEW_STATE', newState);
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_HTML_TEMPLATES_SUCCESS':
      if(newState.templates==undefined){newState.templates={}}
      if(newState.template_instances==undefined){newState.template_instances={}}
      for(let x of action.val){
        let instance=x.html_template_instances[0];
        if(newState.templates[x.id]==undefined){newState.templates[x.id]={}} newState.templates[x.id]={...newState.templates[x.id], ...x, html:instance.html, subject:instance.subject, html_template_instance_id:instance.id, html_template_instances:undefined};
        newState.template_instances[instance.id]=instance;
      }
      newState.templates_index=true;
      newState.refresh+=1;
      break;
    case 'REQUEST_INDEX_EMAIL_SEQUENCES_SUCCESS':
      if(newState.sequences==undefined){newState.sequences={}}
      for(let x of action.val){if(newState.sequences[x.id]==undefined){newState.sequences[x.id]={}} newState.sequences[x.id]={...newState.sequences[x.id], ...x}; newState.sequences[x.id]=x;}
      newState.sequences_index=true;
      break;
    case 'REQUEST_GET_EMAIL_SEQUENCE_SUCCESS':
    case 'REQUEST_CLONE_EMAIL_SEQUENCE_SUCCESS':
    case 'REQUEST_CREATE_EMAIL_SEQUENCE_SUCCESS':
    case 'REQUEST_UPDATE_EMAIL_SEQUENCE_SUCCESS':
      if(newState.sequences==undefined){newState.sequences={}}
      newState.sequences[action.val.id]=action.val;
      newState.refresh+=1;
      break;
    }
  return newState;
}

export default reducer;
